import { forwardRef } from "react";

import { Icon, IconProps } from "../icon";

export type LocationSolidIconProps = IconProps;

export const LocationSolidIcon = forwardRef<
  SVGSVGElement,
  LocationSolidIconProps
>(function LocationSolidIcon(props: LocationSolidIconProps, ref) {
  return (
    <Icon
      data-testid="LocationSolidIcon"
      aria-label="location solid"
      viewBox="0 0 12 12"
      ref={ref}
      {...props}
    >
      <path
        fillRule="evenodd"
        d="M7.56.316A3.868 3.868 0 0 0 6 0c-.555 0-1.075.105-1.56.316A4.066 4.066 0 0 0 2.305 2.45 3.985 3.985 0 0 0 2 4.008a3.922 3.922 0 0 0 .669 2.203L6 12l3.402-5.883c.187-.304.332-.637.434-.996.11-.36.164-.73.164-1.113 0-.555-.102-1.074-.305-1.559a3.969 3.969 0 0 0-.868-1.265A3.973 3.973 0 0 0 7.56.316ZM6 6.004a2.001 2.001 0 1 0 .002-4.002A2.001 2.001 0 0 0 6 6.004Z"
        clipRule="evenodd"
      />
    </Icon>
  );
});
